<template>
  <div class="aside">
    <div class="nav-bar">
      <el-menu
        class="aside"
        :default-openeds="defaultOpeneds"
        router
        :default-active="$route.name"
      >
        <el-menu-item index="home" :route="{ name: 'home' }"><i class="nav-icon icon1"></i><span slot="title">工作台</span></el-menu-item>
        <el-menu-item index="customerManagement" :route="{ name: 'customerManagement' }"><i class="nav-icon icon2"></i><span slot="title">用户管理</span></el-menu-item>
        <el-menu-item index="visitorManagement" :route="{ name: 'visitorManagement' }"><i class="nav-icon icon3"></i><span slot="title">访客管理</span></el-menu-item>
        <el-menu-item index="sessionManagement" :route="{ name: 'sessionManagement' }"><i class="nav-icon icon4"></i><span slot="title">会话管理</span></el-menu-item>
        <el-submenu index="5">
          <template slot="title"><i class="nav-icon icon5"></i><span>数据统计</span></template>
          <el-menu-item-group>
            <el-menu-item index="usersStatistics" :route="{ name: 'usersStatistics' }">用户统计</el-menu-item>
            <el-menu-item index="visitorsStatistics" :route="{ name: 'visitorsStatistics' }">访客统计</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title"><i class="nav-icon icon6"></i><span>权限管理</span></template>
          <el-menu-item-group>
            <!-- <el-menu-item index="roleList" :route="{ name: 'roleList' }">角色列表</el-menu-item> -->
            <el-menu-item index="userList" :route="{ name: 'userList' }">组织管理</el-menu-item>
            <el-menu-item index="updateLog" :route="{ name: 'updateLog' }">更新日志</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "Aside",
  data() {
    return {
      defaultOpeneds: ["5","6"],
    };
  },
};
</script>
